import React, { memo, forwardRef } from "react";
const SvgLesserthan = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M23.894 8.553a1 1 0 00-1.342-.447l-14 7a1 1 0 000 1.789l14 7a1 1 0 10.895-1.789L11.236 16l12.21-6.105a1 1 0 00.448-1.342z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgLesserthan.displayName = "SvgLesserthan";
const MemoForwardRef = memo(SvgLesserthan);
export default MemoForwardRef;
